var base = require('base/js/search/search');
var searchFilter = require('./searchFilter');

function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    updateDom($results, '.refinements');
}

function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

function hideFilter() {
    const filterContainer = document.querySelector("#refinement-bar");
    const body = document.querySelector('#body-scroll');
    filterContainer.style.display = "none";
    body.classList.remove('scroll-none')
}

module.exports = {

    sort : function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
    
            $.spinner().start();
            localStorage.setItem('selectedSortingURL', this.value);
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    
    ApplyFilter : function () {
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
    
                $.spinner().start();
                $(this).trigger('search:filter', e);
                var attributeId = '#' + $(this).find('span').last().attr('id');
                var sortingSelectedUrl;
                if(localStorage.getItem('selectedSortingURL')) {
                    sortingSelectedUrl = localStorage.getItem('selectedSortingURL');
                }
                else {
                    sortingSelectedUrl = $('select[name="sort-order"] option:selected').val();
                }
                var sortingSelected = new URL(sortingSelectedUrl);
                var srule = sortingSelected.searchParams.get("srule");
                var filtersToSortings = searchFilter.extractFilters($(this).data('href'));
                searchFilter.updateSelectOptions($('select[name=sort-order]') , filtersToSortings);
                
                $.ajax({
                    url: $(this).data('href') + `&srule=${srule}`,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $(attributeId).parent('button').focus();
                        $('.refinements').each(function(){
                            var filterName = $($(this)).data('name');
                            if (filterName == 'Precio') {
                                $(this).find('.r-price').addClass('selected');
                            }
    
                                $(`.refinement.refinements-desktop[data-name="${filterName}"] .card-header`).attr('aria-expanded', 'true');
                                $(`.refinement.refinements-desktop[data-name="${filterName}"] .card-body`).addClass('show');       
                        })
    
                        $('.refinements.refinements-desktop .info-size').on('click', function(){
           
                            var $button = $(this).find('.filter-collapse-button');
    
                             if ($button.hasClass('collapsed')) {
                                 $button.removeClass('collapsed');
                             } else {
                                 $button.addClass('collapsed');
                             }
                            })
    
                            $('#close-mobile-filter').on('click', function (){
                                hideFilter();
                            })
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            }
        );
    
    },
    closeRefinements: base.closeRefinements,
    filter: base.filter,
    showMore: base.showMore,
    resize: base.resize,
    showContentTab: base.showContentTab
}